import { RootState } from 'core/redux/types';
import { FirstVisitStep } from './types';

export function isFirstVisitOpen(state: RootState): boolean {
    return state.firstVisit.open;
}

export function getStep(state: RootState): FirstVisitStep {
    return state.firstVisit.step;
}

export function getError(state: RootState): string | null {
    return state.firstVisit.error;
}
